module.exports = __webpack_public_path__ + "static/media/fullstack.b5d0a9d2.jpg";